import { mapGetters } from 'vuex';
export default {
  name: 'Footer',
  computed: {
    ...mapGetters(['userConfig']),
    footerLink() {
      return this.userConfig?.footerLink || 'https://sanyue.site';
    }
  }
};